import React from 'react';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

const MapWithAMarker = withScriptjs(
  withGoogleMap(({ lat, lng, onClick }) => {
    return (
      <GoogleMap
        defaultZoom={15}
        defaultCenter={{ lat, lng }}
        key={lat + lng}
        onClick={onClick}>
        <Marker position={{ lat, lng }} />
      </GoogleMap>
    );
  }),
);

export default MapWithAMarker;
